import { NgModule } from "@angular/core";
import { ButtonComponent } from "./components/button/button.component";
import { CheckboxComponent } from "./components/checkbox/checkbox.component";
import { DateComponent } from "./components/date/date.component";
import { DynamicFieldDirective } from "./components/dynamic-field/dynamic-field.directive";
import { DynamicFormComponent } from "./components/dynamic-form/dynamic-form.directive";
import { InputComponent } from "./components/input/input.component";
import { RadiobuttonComponent } from "./components/radiobutton/radiobutton.component";
import { SelectComponent } from "./components/select/select.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ThemeModule } from "app/@theme/theme.module";
import { MaterialModule } from "app/material.module";
import { AutocompleteComponent } from "./components/autocomplete/autocomplete.component";
import { TableComponent } from "./components/table/table.component";
import { NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap";
import { EspacioEnBlancoComponent } from "./components/espacio-en-blanco/espacio-en-blanco.component";
import { SeparadorComponent } from "./components/separador/separador.component";
import { ConfirmationDialogComponent } from "./confirmation-dialog/component/confirmation-dialog.component";
import { ConfirmationDialogService } from "./confirmation-dialog/service/confirmation-dialog.service";
import { SharedModule } from "app/shared/shared.module";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { SubmitComponent } from "./components/submit/submit.component";
import { OneToManyComponent } from "./components/one-to-many/components/one-to-many.component";
import { MatTableModule } from '@angular/material/table'
import { ModalAbmComponent } from "./components/one-to-many/modal-abm/modal-abm.component";
import { MultipleSelectComponent } from "./components/select-multiple/select-multiple.component";
import { NbActionsModule, NbCardModule } from "@nebular/theme";
import { FileUploaderComponent } from "./components/file-uploader/file-uploader.component";
import { MatFileUploadModule } from "angular-material-fileupload";
import { TextAreaComponent } from "./components/text-area/text-area.component";
import { HistorialComponent } from "./components/historial/historial.component";
import { MAT_DATE_FORMATS } from "@angular/material/core";
import { MatPaginatorIntl, MatPaginatorModule } from "@angular/material/paginator";
import { getEspPaginatorIntl } from "./components/table/table.paginatior.initl";
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

@NgModule({
  declarations: [
    InputComponent,
    FileUploaderComponent,
    ButtonComponent,
    SelectComponent,
    DateComponent,
    RadiobuttonComponent,
    CheckboxComponent,
    DynamicFieldDirective,
    DynamicFormComponent,
    AutocompleteComponent,
    TableComponent,
    EspacioEnBlancoComponent,
    SeparadorComponent,
    ConfirmationDialogComponent,
    SpinnerComponent,
    SubmitComponent,
    OneToManyComponent,
    ModalAbmComponent,
    MultipleSelectComponent,
    TextAreaComponent,
    HistorialComponent
  ],
  imports: [
    NbCardModule,
    ThemeModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    NgbPaginationModule,
    SharedModule,
    MatTableModule,
    NbActionsModule,
    MatFileUploadModule,
    MatPaginatorModule
  ],
  exports: [
    InputComponent,
    FileUploaderComponent,
    ButtonComponent,
    SelectComponent,
    DateComponent,
    RadiobuttonComponent,
    CheckboxComponent,
    DynamicFieldDirective,
    DynamicFormComponent,
    AutocompleteComponent,
    TableComponent,
    EspacioEnBlancoComponent,
    SeparadorComponent,
    SpinnerComponent,
    SubmitComponent,
    ModalAbmComponent,
    MultipleSelectComponent,
    TextAreaComponent,
    HistorialComponent,
    MatPaginatorModule
  ],
  entryComponents: [
    InputComponent,
    FileUploaderComponent,
    ButtonComponent,
    SelectComponent,
    DateComponent,
    RadiobuttonComponent,
    CheckboxComponent,
    AutocompleteComponent,
    TableComponent,
    EspacioEnBlancoComponent,
    SeparadorComponent,
    ConfirmationDialogComponent,
    SpinnerComponent,
    SubmitComponent,
    ModalAbmComponent,
    MultipleSelectComponent,
    TextAreaComponent,
    HistorialComponent,
    MatTableModule,
    
  ],
  providers: [ConfirmationDialogService, { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: MatPaginatorIntl, useValue: getEspPaginatorIntl() }]
})
export class GenericCrudModule { }
